import React from "react"
import { View } from "react-native"

const FormDivider = () => {
  return (
    <View className="w-[264px] h-px border border-zinc-300 justify-center items-center mt-3 mb-6 mx-auto" />
  )
}

export default FormDivider
